// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const dist = sessionStorage.getItem("dist");

// const previewContainerStyle = {
//   width: "365px",
//   minHeight: "557px",
//   maxHeight: "667px",
//   margin: "10px auto",
//   border: "1px solid #ccc",
//   borderRadius: "20px",
//   overflow: "hidden",
//   boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//   backgroundColor: "#f8f9fa",
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "space-between",
//   fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   color: "rgb(14, 57, 114)",
// };

// const headerStyle = {
//   height: "100px",
//   backgroundColor: "#fff",
//   borderRadius: 0,
//   boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//   display: "flex",
//   flexDirection: "column",
// };

// const headerTopStyle = {
//   height: "70px",
//   backgroundColor: "#fff",
//   display: "flex",
//   alignItems: "center",
//   paddingLeft: "10px",
//   gap: "10px",
// };

// const buttonStyle = {
//   padding: "8px 12px",
//   backgroundColor: "rgb(14, 57, 114)",
//   color: "white",
//   border: "none",
//   borderRadius: "4px",
//   cursor: "pointer",
//   fontWeight: "bold",
//   display: "flex",
//   alignItems: "center",
//   justifyContent:'center',
//   gap: "6px",
// };

// const profileTextStyle = {
//   fontWeight: "bold",
//   fontSize: "22px",
//   marginLeft: "15px",
// };

// const scrollViewStyle = {
//   flex: 1,
//   overflowY: "auto",
//   padding: "10px 14px",
// };

// const cardStyle = {
//   marginBottom: "12px",
//   minHeight: "65px",
//   backgroundColor: "#fff",
//   borderRadius: "4px",
//   boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//   padding: "10px",
//   display: "flex",
//   alignItems: "center",
//   fontSize: "17px",
//   color: "rgb(14, 57, 114)",
// };

// const imageWrapperStyle = {
//   width: "130px",
//   height: "130px",
//   borderRadius: "65px",
//   backgroundColor: "#fff",
//   boxShadow: "0 2px 7px rgba(0,0,0,0.15)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   margin: "0 auto 10px auto",
// };

// const imageStyle = {
//   height: "124px",
//   width: "124px",
//   borderRadius: "62px",
//   objectFit: "cover",
// };

// const updateButtonsRowStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginTop: "15px",
//   gap: "6px",
// };

// const inputStyle = {
//   height: "40px",
//   borderRadius: "4px",
//   boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//   border: "1px solid #ccc",
//   backgroundColor: "#fff",
//   margin: "10px 7px",
//   paddingLeft: "8px",
//   fontSize: "15px",
//   color: "rgb(14, 57, 114)",
//   width: "calc(100% - 28px)",
// };

// const datePickerStyle = {
//   ...inputStyle,
//   cursor: "pointer",
//   display: "flex",
//   alignItems: "center",
//   color: "#000",
//   justifyContent: "flex-start",
// };

// const placeholderColor = "#aaa";

// function ProfilePage() {
//   const navigate = useNavigate();

//   const [member, setMember] = useState([]);
//   const [isUpdate, setIsUpdate] = useState(false);
//   const [isShowGM, setIsShowGM] = useState(false);
//   const [mobile, setMobile] = useState(""); // fetched login email/mobile
// const [profilePic, setProfilePic] = useState(member[0]?.photo || "");
// const fileInputRef = React.useRef(null);


//   const [formData, setFormData] = useState({
//     membershipName: "",
//     email: "",
//     clubs: "",
//     spouseName: "",
//     birthAnniversary: "",
//     marriageAnniversary: "",
//     bloodGroup: "",
//     joiningDate: "",
//     address: "",
//     profession: "",
//   });

//   const [showDatePicker, setShowDatePicker] = useState({ type: null, visible: false });

//   // 🟢 📡 Fetch initial profile on mount
//   useEffect(() => {
//     const loginMobile = sessionStorage.getItem("loginMobile");
//     if (loginMobile) {
//       getProfile(loginMobile);
//     }
//   }, []);

//   // 📞 Retrieve profile data
//   const getProfile = async (mobile) => {
//     try {
//       const res = await axios.post("https://lionsdirectoryapi.emedha.in/profile", {
//         mobile,
//         dist
//       });
//       setMember(res.data);
//       setMobile(mobile);
//     } catch (err) {
//       console.error("Profile fetch error:", err);
//     }
//   };

//   // ✏️ Prepare form for update
//   const getProfileUpdateData = (mobile) => {
//     if (member[0]) {
//       const m = member[0];
//       setFormData({
//         membershipName: m.membershipName,
//         email: m.email,
//         clubs: m.clubs,
//         spouseName: m.spouseName,
//         birthAnniversary: m.birthAnniversary,
//         marriageAnniversary: m.marriageAnniversary,
//         bloodGroup: m.bloodGroup,
//         joiningDate: m.joiningDate,
//         address: m.address,
//         profession: m.profession,
//       });
//       setIsUpdate(true);
//     }
//   };

//   // 🛠️ Update profile via POST
//   const updateProfile = async () => {
//     try {
//       await axios.post("https://lionsdirectoryapi.emedha.in/update/profile/post", {
//         ...formData,
//         mobile,
//         dist
//       });
//       alert("Update Successful");
//       await getProfile(mobile);
//       setIsUpdate(false);
//     } catch (err) {
//       console.error("Profile update failed:", err);
//     }
//   };

//   // 🗑️ Delete confirmation + API
//   const twoOptionAlertHandler = async () => {
//     if (window.confirm("Warning! Delete your profile?")) {
//       try {
//         await axios.post("https://lionsdirectoryapi.emedha.in/profile/delete", {
//           mobile,
//           dist
//         });
//         alert("Deleted successfully");
//         navigate("/home");
//       } catch (err) {
//         console.error("Delete failed:", err);
//       }
//     }
//   };

//   // 📸 Open camera prompt
//   const cameraHandler = () => {
//     alert("Camera logic would go here...");
//     setIsShowGM(false);
//   };

//   // 📁 Upload a new profile image via picker (web version)
// const handleImageUpload = () => {
//   if (fileInputRef.current) {
//     fileInputRef.current.click();
//   }
// };

// // const onFileChange = (event) => {
// //   const file = event.target.files[0];
// //   if (file) {
// //     const reader = new FileReader();
// //     reader.onloadend = () => {
// //       setProfilePic(reader.result); // Update preview
// //       // TODO: Upload to backend if needed
// //     };
// //     reader.readAsDataURL(file);
// //   }
// //   setIsShowGM(false);
// // };

// const onFileChange = async (event) => {
//   const file = event.target.files[0];
//   if (!file) return;

//   // Show preview immediately
//   setProfilePic(URL.createObjectURL(file));

//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("dist", dist);
//   formData.append("mobile", mobile);

//   try {
//     const response = await axios.post(
//       "https://lionsdirectoryapi.emedha.in/upload-file-320e",
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );

//     console.log("Upload response:", response.data);

//     if (response.data) {
//       setProfilePic(response.data.photo); // set uploaded image URL from server
//       alert("Upload successful!");
//       getProfile(mobile)
//     } else {
//       alert("Upload succeeded, but no URL returned.");
//     }
//   } catch (error) {
//     console.error("Upload failed:", error);
//     alert("Upload failed. Please try again.");
//   }

//   setIsShowGM(false);
// };




//   // 🧩 Input and date picker handlers
//   const onInputChange = (val, name) => setFormData((p) => ({ ...p, [name]: val }));
//   const handleDateChange = (e) => {
//     setFormData((p) => ({ ...p, [showDatePicker.type]: e.target.value }));
//     setShowDatePicker({ type: null, visible: false });
//   };

//   return (
//     <div style={previewContainerStyle}>
//       {/* HEADER */}
//       <header style={headerStyle}>
//         <div style={headerTopStyle}>
//           <button onClick={() => navigate("/home")} style={{ ...buttonStyle, backgroundColor: "transparent", color: "rgb(14,57,114)" }}>
//             ← 🏠
//           </button>
//           <div style={{ marginLeft: isUpdate ? 15 : 40, fontWeight: "bold", fontSize: 22 }}>
//             {isUpdate ? "update profile" : "profile"}
//           </div>
//         </div>
//       </header>

//       {/* CONTENT */}
//       <main style={scrollViewStyle}>
//         {!isUpdate ? (
//           member.map((mem, idx) => (
//             <div key={idx} style={{ marginBottom: 20 }}>
//               {/* Photo + Edit */}
//               <div style={{ textAlign: "center", marginBottom: 10 }}>
//                 <div style={imageWrapperStyle}>
//                   <img src={mem.photo} alt="Profile" style={imageStyle} loading="lazy" />
//                 </div>
//                 {!isShowGM ? (
//                     <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
//                   <button onClick={() => setIsShowGM(true)} style={{ ...buttonStyle, marginTop: 5, backgroundColor: "orange" }}>
//                     📷 update
//                   </button>
//                   </div>
//                 ) : (
//                   <div style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     marginTop: 7,
//                     backgroundColor: "#fff",
//                     boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//                     borderRadius: 10,
//                     padding: 6,
//                     gap: "10px",
//                     color: "orange",
//                     fontSize: 26,
//                     cursor: "pointer"
//                   }}>
//                        <span onClick={cameraHandler} role="button" tabIndex={0} style={{ cursor: "pointer" }}>
//       📷
//     </span>
//     <span onClick={handleImageUpload} role="button" tabIndex={0} style={{ cursor: "pointer" }}>
//       🖼️
//     </span>

//                   </div>
//                 )}
//               </div>

//               {/* Info */}
//               {[
//                 `Membership Number: ${mem.membershipNo}`,
//                 `Name: ${mem.membershipName}`,
//                 `Email: ${mem.email}`,
//                 `Mobile: ${mem.mobile}`,
//                 `Club Name: ${mem.clubs}`,
//                 `Spouse Name: ${mem.spouseName}`,
//                 `DOB: ${mem.birthAnniversary}`,
//                 `DOM: ${mem.marriageAnniversary}`,
//                 `Blood Group: ${mem.bloodGroup}`,
//                 `Joining Date: ${mem.joiningDate}`,
//                 `Address: ${mem.address}`,
//                 `Profession: ${mem.profession}`
//               ].map((txt, i) => (
//                 <div key={i} style={cardStyle}>{txt}</div>
//               ))}

//               {/* Edit/Delete Buttons */}
//               <div style={updateButtonsRowStyle}>
//                 <button onClick={() => getProfileUpdateData(mobile)} style={buttonStyle}>✏️ update</button>
//                 <button onClick={twoOptionAlertHandler} style={{ ...buttonStyle, backgroundColor: "red" }}>🗑️ delete</button>
//               </div>
//             </div>
//           ))
//         ) : (
//           <>
//             {/* Update Form */}
//             {Object.entries(formData).map(([key, value]) =>
//               key.includes("Anniversary") || key === "joiningDate" ? (
//                 <div key={key}>
//                   <div style={datePickerStyle} onClick={() => setShowDatePicker({ type: key, visible: true })}>
//                     {value || key.replace(/([A-Z])/g, " $1").toLowerCase()}
//                   </div>
//                   {showDatePicker.visible && showDatePicker.type === key && (
//                     <input type="date" value={value} onChange={handleDateChange} style={inputStyle} />
//                   )}
//                 </div>
//               ) : (
//                 <input
//                   key={key}
//                   type="text"
//                   placeholder={key.replace(/([A-Z])/g, " $1").toLowerCase()}
//                   value={value || ""}
//                   onChange={(e) => onInputChange(e.target.value, key)}
//                   style={inputStyle}
//                 />
//               )
//             )}
// <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
//   <button onClick={updateProfile} style={{ ...buttonStyle }}>
//     ✏️ Update Profile
//   </button>
// </div>



//           </>
//         )}
//       </main>
//       <input
//   type="file"
//   accept="image/*"
//   ref={fileInputRef}
//   onChange={onFileChange}
//   style={{ display: "none" }}
// />
//     </div>
//   );
// }

// export default ProfilePage;

// import React, { useState } from 'react';

// import { ChevronLeft, Hash, Building2, Phone, Mail, MapPin, Edit3, LogOut, User } from 'lucide-react';

// const ProfilePage = ({ onBack, onLogout, styles }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [userData, setUserData] = useState({
//     membership: 'LC123456',
//     club: 'Downtown Lions Club',
//     phone: '+1 (555) 123-4567',
//     email: 'john.anderson@email.com',
//     address: '123 Main Street, City, State 12345'
//   });

//   const handleUpdateToggle = () => {
//     if (isEditing) {
//       // Logic to save data would go here
//       console.log("Saved Data:", userData);
//     }
//     setIsEditing(!isEditing);
//   };

//   const handleChange = (field, value) => {
//     setUserData(prev => ({ ...prev, [field]: value }));
//   };

//   const ProfileField = ({ icon: Icon, label, value, field }) => (
//     <div style={{
//       backgroundColor: 'white', borderRadius: '12px', padding: '12px 15px',
//       marginBottom: '12px', border: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '15px'
//     }}>
//       <div style={{ color: '#0033A0', opacity: 0.7 }}>
//         <Icon size={20} />
//       </div>
//       <div style={{ flex: 1 }}>
//         <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>{label}</div>
//         {isEditing ? (
//           <input 
//             type="text" 
//             value={value} 
//             onChange={(e) => handleChange(field, e.target.value)}
//             style={{ 
//               width: '100%', border: 'none', borderBottom: '1px solid #0033A0', 
//               fontSize: '14px', color: '#000', outline: 'none', padding: '2px 0' 
//             }} 
//           />
//         ) : (
//           <div style={{ fontSize: '14px', color: '#000', fontWeight: '600' }}>{value}</div>
//         )}
//       </div>
//     </div>
//   );

//   return (
//     <div style={styles.scrollArea}>
//       {/* Back Button Section */}
//       <div 
//         onClick={onBack} 
//         style={{ padding: '15px', display: 'flex', alignItems: 'center', color: '#0033A0', cursor: 'pointer' }}
//       >
//         <ChevronLeft size={20} />
//         <span style={{ fontSize: '14px', fontWeight: '600' }}>Back to Home</span>
//       </div>

//       {/* Profile Header Card */}
//       <div style={{ textAlign: 'center', padding: '10px 0 25px' }}>
//         <div style={{ 
//           width: '90px', height: '90px', borderRadius: '50%', margin: '0 auto 15px',
//           background: 'linear-gradient(135deg, #0033A0, #FFC20E)',
//           display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white'
//         }}>
//           <User size={45} />
//         </div>
//         <h2 style={{ margin: '0', fontSize: '22px', color: '#0033A0' }}>John Anderson</h2>
//         <p style={{ margin: '4px 0 0', fontSize: '14px', color: '#666' }}>Downtown Lions Club</p>
//       </div>

//       {/* Profile Fields */}
//       <div style={{ padding: '0 15px' }}>
//         <ProfileField icon={Hash} label="Membership Number" value={userData.membership} field="membership" />
//         <ProfileField icon={Building2} label="Club" value={userData.club} field="club" />
//         <ProfileField icon={Phone} label="Phone" value={userData.phone} field="phone" />
//         <ProfileField icon={Mail} label="Email" value={userData.email} field="email" />
//         <ProfileField icon={MapPin} label="Address" value={userData.address} field="address" />

//         {/* Action Buttons */}
//         <div style={{ marginTop: '25px' }}>
//           <button 
//             onClick={handleUpdateToggle}
//             style={{
//               width: '100%', backgroundColor: '#FFC20E', color: '#333', border: 'none',
//               padding: '14px', borderRadius: '10px', fontWeight: 'bold', fontSize: '15px',
//               display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px',
//               cursor: 'pointer', marginBottom: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//             }}
//           >
//             <Edit3 size={18} /> {isEditing ? 'Save Changes' : 'Update Profile'}
//           </button>

//           <button 
//             onClick={onLogout}
//             style={{
//               width: '100%', backgroundColor: 'transparent', color: '#B22222', 
//               border: '2px solid #B22222', padding: '12px', borderRadius: '10px', 
//               fontWeight: 'bold', fontSize: '15px', display: 'flex', 
//               justifyContent: 'center', alignItems: 'center', gap: '8px', cursor: 'pointer'
//             }}
//           >
//             <LogOut size={18} /> Logout
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;


import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// Icons used to match the screenshot style
import { 
  Bell, User, Hash, Building2, Phone, Mail, MapPin, 
  Edit3, LogOut, ChevronLeft, Heart, Briefcase, Calendar, Users
} from "lucide-react";

const dist = sessionStorage.getItem("dist");

const styles = {
  container: {
    width: "375px",
    height: "100vh",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    fontFamily: "sans-serif",
    position: "relative",
    overflow: "hidden",
    border: "1px solid #ddd"
  },

  buttonContainer: {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "25px",
  gap: "12px",
},
  header: {
    backgroundColor: "#0033A0",
    color: "white",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "4px solid #FFC20E",
    flexShrink: 0
  },
  content: {
    flex: 1,
    overflowY: "auto",
    paddingBottom: "100px",
  },
  backBtn: {
    padding: "15px",
    display: "flex",
    alignItems: "center",
    color: "#0033A0",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer"
  },
  profileHeader: {
    textAlign: "center",
    padding: "10px 0 25px"
  },
  imageWrapper: {
    width: "110px",
    height: "110px",
    borderRadius: "50%",
    margin: "0 auto 15px",
    background: "linear-gradient(135deg, #0033A0, #FFC20E)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    overflow: "hidden",
    position: "relative",
    border: "3px solid #fff",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
  },
  profilePic: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  fieldCard: {
    backgroundColor: "white",
    borderRadius: "12px",

    padding: "12px 15px",
    marginBottom: "12px",
    border: "1px solid #eee",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    margin: "0 15px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
  },
  iconBox: {
    color: "#0033A0",
    opacity: 0.7,
    width: "24px",
    display: "flex",
    justifyContent: "center"
  },
  input: {
    width: "100%",
    
    border: "none",
    borderBottom: "1px solid #0033A0",
    fontSize: "14px",
    color: "#000",
    outline: "none",
    padding: "4px 0",
    backgroundColor: "transparent"
  },
  yellowBtn1: {
    backgroundColor: "#FFC20E",
    color: "#333",
    border: "none",
    padding: "14px",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    margin: "25px 15px 12px 15px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      width: "180px",
  },
  yellowBtn: {
    backgroundColor: "#FFC20E",
    color: "#333",
    border: "none",
    padding: "14px",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    margin: "25px 15px 12px 15px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      width: "90%",
  },
  logoutBtn: {
    backgroundColor: "transparent",
    color: "#B22222",
    border: "2px solid #B22222",
    padding: "12px",
    borderRadius: "10px",
      width: "90%",
    fontWeight: "bold",
    fontSize: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    margin: "0 15px 30px 15px"
  }
};

function ProfilePage({ onBack }) {
  const navigate = useNavigate();
  const [member, setMember] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isShowGM, setIsShowGM] = useState(false);
  const [mobile, setMobile] = useState("");
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    membershipName: "",
    email: "",
    clubs: "",
    spouseName: "",
    birthAnniversary: "",
    marriageAnniversary: "",
    bloodGroup: "",
    joiningDate: "",
    address: "",
    profession: "",
  });

  useEffect(() => {
    const loginMobile = sessionStorage.getItem("loginMobile");
    if (loginMobile) {
      getProfile(loginMobile);
    }
  }, []);

  const getProfile = async (mobile) => {
    try {
      const res = await axios.post("https://lionsdirectoryapi.emedha.in/profile", { mobile, dist });
      setMember(res.data);
      setMobile(mobile);
      if (res.data[0]) {
        const m = res.data[0];
        setFormData({
          membershipName: m.membershipName,
          email: m.email,
          clubs: m.clubs,
          spouseName: m.spouseName,
          birthAnniversary: m.birthAnniversary,
          marriageAnniversary: m.marriageAnniversary,
          bloodGroup: m.bloodGroup,
          joiningDate: m.joiningDate,
          address: m.address,
          profession: m.profession,
        });
      }
    } catch (err) { console.error("Fetch error:", err); }
  };

  const updateProfile = async () => {
    try {
      await axios.post("https://lionsdirectoryapi.emedha.in/update/profile/post", { ...formData, mobile, dist });
      alert("Update Successful");
      await getProfile(mobile);
      setIsUpdate(false);
    } catch (err) { console.error("Update failed:", err); }
  };

  const onFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const uploadData = new FormData();
    uploadData.append("file", file);
    uploadData.append("dist", dist);
    uploadData.append("mobile", mobile);
    try {
      const res = await axios.post("https://lionsdirectoryapi.emedha.in/upload-file-320e", uploadData);
      if (res.data) {
        alert("Upload successful!");
        getProfile(mobile);
      }
    } catch (err) { alert("Upload failed."); }
    setIsShowGM(false);
  };

  const onInputChange = (val, name) => setFormData(p => ({ ...p, [name]: val }));

  return (
    <div style={styles.container}>
     

      <main style={styles.content}>
        <div style={styles.backBtn} onClick={() =>  onBack()}>
          <ChevronLeft size={20} /> <span>Back to Home</span>
        </div>

        <div style={styles.profileHeader}>
          <div style={styles.imageWrapper}>
            <img src={member[0]?.photo} alt="Profile" style={styles.profilePic} />
          </div>
          {!isShowGM ? (
            <button onClick={() => setIsShowGM(true)} style={{ ...styles.yellowBtn1, margin: "0 auto", padding: "8px 20px" }}>
              📷 Update Picture
            </button>
          ) : (
            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "10px" }}>
              <span onClick={() => fileInputRef.current.click()} style={{ cursor: "pointer", fontSize: "24px" }}>🖼️ Gallery</span>
              <span onClick={() => setIsShowGM(false)} style={{ cursor: "pointer", fontSize: "24px" }}>❌</span>
            </div>
          )}
          <h2 style={{ margin: "15px 0 0", color: "#0033A0" }}>{formData.membershipName}</h2>
        </div>

        {/* ALL INPUTS FROM YOUR COMPONENT RENDERED IN NEW UI STYLE */}
        <ProfileField icon={<Hash />} label="Membership Number" value={member[0]?.membershipNo} />
        <ProfileField icon={<User />} label="Name" value={formData.membershipName} isEdit={isUpdate} name="membershipName" onChange={onInputChange} />
        <ProfileField icon={<Mail />} label="Email" value={formData.email} isEdit={isUpdate} name="email" onChange={onInputChange} />
        <ProfileField icon={<Building2 />} label="Club" value={formData.clubs} isEdit={isUpdate} name="clubs" onChange={onInputChange} />
        <ProfileField icon={<Users />} label="Spouse Name" value={formData.spouseName} isEdit={isUpdate} name="spouseName" onChange={onInputChange} />
        <ProfileField icon={<Calendar />} label="DOB" value={formData.birthAnniversary} isEdit={isUpdate} name="birthAnniversary" type="date" onChange={onInputChange} />
        <ProfileField icon={<Calendar />} label="Marriage Anniversary" value={formData.marriageAnniversary} isEdit={isUpdate} name="marriageAnniversary" type="date" onChange={onInputChange} />
        <ProfileField icon={<Heart />} label="Blood Group" value={formData.bloodGroup} isEdit={isUpdate} name="bloodGroup" onChange={onInputChange} />
        <ProfileField icon={<Calendar />} label="Joining Date" value={formData.joiningDate} isEdit={isUpdate} name="joiningDate" type="date" onChange={onInputChange} />
        <ProfileField icon={<MapPin />} label="Address" value={formData.address} isEdit={isUpdate} name="address" onChange={onInputChange} />
        <ProfileField icon={<Briefcase />} label="Profession" value={formData.profession} isEdit={isUpdate} name="profession" onChange={onInputChange} />

       <div style={styles.buttonContainer}>
  <button
    style={styles.yellowBtn}
    onClick={isUpdate ? updateProfile : () => setIsUpdate(true)}
  >
    <Edit3 size={18} />
    {isUpdate ? "Save Profile" : "Update Profile"}
  </button>

  {!isUpdate && (
    <button
      style={styles.logoutBtn}
      onClick={() => {
        sessionStorage.clear();
 onBack();
      }}
    >
      <LogOut size={18} />
      Logout
    </button>
  )}
</div>
      </main>

      <input type="file" ref={fileInputRef} onChange={onFileChange} style={{ display: "none" }} accept="image/*" />
    </div>
  );
}

const ProfileField = ({ icon, label, value, isEdit, name, type = "text", onChange }) => (
  <div style={styles.fieldCard}>
    <div style={styles.iconBox}>{icon}</div>
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: "11px", color: "#888", marginBottom: "2px" }}>{label}</div>
      {isEdit ? (
        <input 
          type={type} 
          style={styles.input} 
          value={value || ""} 
          onChange={(e) => onChange(e.target.value, name)} 
        />
      ) : (
        <div style={{ fontSize: "14px", color: "#000", fontWeight: "600" }}>{value || "Not Set"}</div>
      )}
    </div>
  </div>
);

export default ProfilePage;